var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37748 34.0013L4.56873 2.5H35.4312L32.6187 33.9963L19.9812 37.5L7.37748 34.0013Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.8224L30.2125 31.9912L32.615 5.07617H20V34.8224Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7587H14.8875L14.535 12.8025H20V8.93872H10.3125L10.405 9.97622L11.3538 20.6225H20V16.7587ZM20 26.7925L19.9825 26.7975L15.68 25.6362L15.405 22.555H11.5262L12.0675 28.62L19.9825 30.8175L20 30.8125V26.7925Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 16.7587V20.6225H24.7437L24.2962 25.6337L19.9862 26.7962V30.8162L27.9075 28.62L27.965 27.9675L28.8725 17.7962L28.9675 16.7587H19.9862ZM19.9862 8.93872V12.8025H29.3187L29.3962 11.935L29.5725 9.97622L29.665 8.93872H19.9862Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.fa08418b0a22331138fa53bfeba6ea06.svg";
export { ForwardRef as ReactComponent };